<template>
  <div class="pt-x1 pb-x1" v-if="zoho">
    <button class="avatar-with-name zero-btn" v-for="(date, index) in datesArray" :key="index" @click="$emit('filterEmit', date)" :class="{ 'selected' : activeFilters.includes(date) }">
      <div class="user-name">{{ formatDate(date) }}</div>
    </button>
  </div>
  <div class="pt-x1 pb-x1" v-else>
    <button class="avatar-with-name zero-btn" v-for="(date, index) in datesArray" :key="index" @click="$emit('filterEmit', date.date)" :class="{ 'selected' : activeFilters.includes(date.date) }">
      <div class="user-name">{{ formatDate(date.date) }}</div>
    </button>
    <!--  on parent, attach @filterEmit="yourMethod" to component reference, no parentheses on method call -> will auto send variable to that method for processing -->
  </div>
</template>

<script>
import shared from '@/shared.js'

export default {
  name: 'DatesList',
  props: {
    dates: {
      type: Array,
      default: () => []
    },
    activeFilters: {
      type: Array,
      default: () => []
    },
    zoho: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    dates: function () {
      this.setDatesArray()
    },
    activeFilters: function () {
      this.setActiveFilters()
    }
  },
  data () {
    return {
      isLoggedIn: false,
      datesArray: [],
      filtersArray: []
    }
  },
  components: {},
  created () {
    this.setDatesArray()
  },
  mounted () {},
  computed: {},
  methods: {
    goHome () {
      this.$router.push({ path: '/' })
    },
    setDatesArray () {
      this.datesArray = this.dates
    },
    setActiveFilters () {
      this.filtersArray = this.activeFilters
    },
    formatDate (date) {
      let month = shared.parseDate(date, 'month')
      let day = shared.parseDate(date, 'day')
      let formattedDate = month.toUpperCase().substring(0, 3) + ' ' + day
      return formattedDate
    },
    parseDate (timestamp, dateSegment = 0) {
      return shared.parseDate(timestamp, dateSegment)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.user-image{
  border-radius: 50%;
  height: 28px;
}
.avatar-stack-item{
  display:inline-block;
  margin-left: -8px;
  &:first-child{
    margin-left:0px;
  }
  .avatar-image {
    box-shadow: 0px 0px 4px 1px rgba(0, 0, 0, 0.2);
  }
}
.avatar-with-name{
  display: inline-flex;
  align-items: center;
  margin-right: 4px;
  margin-bottom: 4px;
  border-radius: 80px;
  border: 1px solid #525f6b;
  padding: 4px;
  background: #fff;
  color: #342F30;
  .user-name{
    padding: 0px 8px;
    font-size: 14px;
  }
  &.selected{
    background: #525f6b;
    color: #fff;
  }
}
// Media Queries
// Small devices (landscape phones, 576px and up)
@media (min-width: 576px) {
  .nav-menu-button{
    .avatar-greeting{
      display: block;
    }
    .avatar-chevron{
      display: none;
    }
  }
  .nav-logo {
    &.nav-logo-mobile {
      display: none;
    }
    &.nav-logo-desktop {
      display: block;
    }
  }
}
// Medium devices (tablets, 768px and up)
@media (min-width: 768px) {
}
// Large devices (desktops, 992px and up)
@media (min-width: 992px) {
}
// Extra large devices (large desktops, 1200px and up)
@media (min-width: 1200px) {
}
</style>
